import { enableFade } from 'core/handlers/FadeHandler'
import { signal } from 'services/SignalsService'
import { debug } from 'settings/custom/build'

export default class SettingsEntity extends PIXI.Container {
  constructor() {
    super()
    const fade = enableFade(this)
    signal.on('RADIO:menu', (value) => {
      fade(value === 'settings')
    })
  }
  register(type, object) {
    if (!game.models.JurisdictionModel.get().turbo) {
      if (type === 'Text' && object.name === 'turbo') {
        object.renderable = false
      }

      if (type === 'ToggleButton' && object._data.name === 'turbo') {
        object.renderable = false
      }
    }

    if (!debug) {
      if (type === 'Text') {
        if (object.name === 'cheat' || object.name === 'fps') {
          object.renderable = false
        }
      }

      if (type === 'ToggleButton') {
        if (object._data.name === 'cheat' || object._data.name === 'fps') {
          object.renderable = false
        }
      }
    }
  }
}
